import { render, staticRenderFns } from "./notification-setting.vue?vue&type=template&id=0538eb81"
import script from "./notification-setting.vue?vue&type=script&lang=js"
export * from "./notification-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports